/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business バグ評価の期間セレクタ（30/90/180/365/all）から評価日時フィルタ用の startDate/endDate を算出する共通ユーティリティ。一覧ページ・マイページのバグ評価タブで共用
 * @graph-connects none
 */

/** Date を YYYY-MM-DD (UTC) 文字列へ整形する @graph-connects none */
export function formatPeriodDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/**
 * 期間選択値（'30' | '90' | '180' | '365' | 'all'）から startDate/endDate を算出する。
 * 'all'（および数値化できない値）は範囲指定なし（両方 undefined）を返す。
 * @graph-connects none
 */
export function computePeriodRange(period: string): { startDate?: string; endDate?: string } {
  const days = Number(period);
  if (period === 'all' || !Number.isFinite(days) || days <= 0) return {};
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);
  return { startDate: formatPeriodDate(start), endDate: formatPeriodDate(end) };
}
